// extracted by mini-css-extract-plugin
export default {"tabContent":"styles__tabContent___D7O3K","body":"styles__body___lSRUl","error":"styles__error___J1__5"};